// 用户数据
export const users = [
  {
    username: 'admin',
    password: 'admin123',
    points: 500
  },
  {
    username: 'test',
    password: 'test123',
    points: 200
  }
];

// 任务状态列表
export const statuses = [
  {
    code: 'waiting',
    name: '待翻译'
  },
  {
    code: 'processing',
    name: '翻译中'
  },
  {
    code: 'completed',
    name: '翻译完成'
  },
  {
    code: 'failed',
    name: '翻译失败'
  },
  {
    code: 'cancelled',
    name: '已取消'
  }
];

// 支持的翻译语种
export const languages = [
  {
    code: 'en',
    name: '英语'
  },
  {
    code: 'ja',
    name: '日语'
  },
  {
    code: 'fr',
    name: '法语'
  }
];

// 模拟任务数据
export const tasks = [
  {
    task_id: 'TASK0001',
    file_name: '身份证.pdf',
    file_format: 'PDF',
    file_type: '身份证',
    file_pages: 2,
    language: 'en',
    points_cost: 20,
    completed_at: '2023-07-10T15:30:00Z',
    status: 'completed',
    created_at: '2023-07-10T14:30:00Z'
  },
  {
    task_id: 'TASK0002',
    file_name: '户口本.jpg',
    file_format: 'JPG',
    file_type: '户口本',
    file_pages: 5,
    language: 'en',
    points_cost: 50,
    completed_at: null,
    status: 'processing',
    created_at: '2023-07-11T09:15:00Z'
  },
  {
    task_id: 'TASK0003',
    file_name: '银行流水-中国银行.docx',
    file_format: 'DOCX',
    file_type: '银行流水-中国银行',
    file_pages: 10,
    language: 'en',
    points_cost: 100,
    completed_at: null,
    status: 'waiting',
    created_at: '2023-07-11T10:45:00Z'
  },
  {
    task_id: 'TASK0004',
    file_name: '出入境记录.pdf',
    file_format: 'PDF',
    file_type: '出入境记录',
    file_pages: 3,
    language: 'en',
    points_cost: 30,
    completed_at: null,
    status: 'failed',
    error_message: '文件无法解析，请重新上传',
    created_at: '2023-07-09T16:20:00Z'
  },
  {
    task_id: 'TASK0005',
    file_name: '车辆驾驶证.png',
    file_format: 'PNG',
    file_type: '车辆驾驶证',
    file_pages: 1,
    language: 'en',
    points_cost: 10,
    completed_at: null,
    status: 'cancelled',
    created_at: '2023-07-08T11:10:00Z'
  },
  {
    task_id: 'TASK0006',
    file_name: '营业执照.pdf',
    file_format: 'PDF',
    file_type: '营业执照',
    file_pages: 1,
    language: 'ja',
    points_cost: 10,
    completed_at: '2023-07-07T16:40:00Z',
    status: 'completed',
    created_at: '2023-07-07T15:30:00Z'
  }
];

// 生成更多模拟任务
export const generateMoreTasks = (count = 20) => {
  const fileNames = ['身份证', '户口本', '银行流水', '出入境记录', '驾驶证', '营业执照', '学历证明', '结婚证', '房产证'];
  const fileFormats = ['PDF', 'JPG', 'PNG', 'DOCX'];
  const statuses = ['waiting', 'processing', 'completed', 'failed', 'cancelled'];
  const languages = ['en', 'ja', 'fr'];

  const newTasks = [];
  
  for (let i = 0; i < count; i++) {
    const fileName = fileNames[Math.floor(Math.random() * fileNames.length)];
    const fileFormat = fileFormats[Math.floor(Math.random() * fileFormats.length)];
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const language = languages[Math.floor(Math.random() * languages.length)];
    const filePages = Math.floor(Math.random() * 10) + 1;
    
    // 创建日期在过去30天内随机
    const createdDate = new Date();
    createdDate.setDate(createdDate.getDate() - Math.floor(Math.random() * 30));
    
    // 完成日期只有在状态为completed时才有
    let completedDate = null;
    if (status === 'completed') {
      completedDate = new Date(createdDate);
      completedDate.setHours(completedDate.getHours() + Math.floor(Math.random() * 24) + 1);
    }
    
    // 错误信息只有在状态为failed时才有
    let errorMessage = null;
    if (status === 'failed') {
      const errors = [
        '文件无法解析，请重新上传',
        '文件格式不支持',
        '翻译服务暂时不可用',
        '文件内容无法识别'
      ];
      errorMessage = errors[Math.floor(Math.random() * errors.length)];
    }
    
    newTasks.push({
      task_id: `TASK${String(i + 7).padStart(4, '0')}`,
      file_name: `${fileName}.${fileFormat.toLowerCase()}`,
      file_format: fileFormat,
      file_type: fileName,
      file_pages: filePages,
      language: language,
      points_cost: filePages * 10,
      completed_at: completedDate ? completedDate.toISOString() : null,
      status: status,
      error_message: errorMessage,
      created_at: createdDate.toISOString()
    });
  }
  
  return [...tasks, ...newTasks];
};

// 创建数据对象后再导出
const allData = {
  users,
  statuses,
  languages,
  tasks: generateMoreTasks()
}; 

export default allData; 